import { useState } from 'react';
import { Row, Col, Container } from 'reactstrap';

import '../../../assets/scss/datatables.scss';
import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import ToList from './toList';
import CreateTOOffcanvas from './CreateTOOffcanvas';
import ReturnTOOffcanvas from './ReturnTOOffcanvas';
import ItemDetailsOffcanvas from './ItemDetailsOffcanvas';
import StaffRequestsOffcanvas from './StaffRequestsOffcanvas';
import StaffRequestItemsOffcanvas from './StaffRequestItemsOffcanvas';
import { useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';

const ManageTO = () => {
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [isReturnOpen, setIsReturnOpen] = useState(false);
  const [isItemDetailsOpen, setItemDetailsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [itemDetailsData, setItemDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [isStaffRequestsOpen, setStaffRequestsOpen] = useState(false);
  const [isRequestDetailsOpen, setRequestDetailsOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const toggleOffcanvas = () => {
    if (isOffcanvasOpen) {
      setEditData(null);
    }
    setOffcanvasOpen(!isOffcanvasOpen);
  };

  const toggleReturn = () => {
    setIsReturnOpen(!isReturnOpen);
  };

  const handleReturnTO = () => {
    setIsReturnOpen(true);
  };

  const handleEditItem = (item) => {
    setEditData(item);
    setOffcanvasOpen(true);
  };

  const { transferOrderList = [] } = useSelector((state) => state.service);

  const handleViewDetails = (to_number) => {
    let list = [];
    if (transferOrderList && Array.isArray(transferOrderList)) {
      list = transferOrderList;
    }
    const toItems = list.filter((i) => i.to_number === to_number);
    console.log(toItems);
    setItemDetailsData({ ...toItems[0], items: toItems });
    setItemDetailsOpen(true);
  };

  const toggleItemDetails = () => {
    setItemDetailsOpen(!isItemDetailsOpen);
    if (isItemDetailsOpen) {
      setItemDetailsData(null);
    }
  };

  const toggleStaffRequests = () => {
    setStaffRequestsOpen(!isStaffRequestsOpen);
  };

  const toggleRequestDetails = () => {
    setRequestDetailsOpen(!isRequestDetailsOpen);
    if (isRequestDetailsOpen) {
      setSelectedRequest(null);
    }
  };

  const handleViewRequestDetails = (request) => {
    setSelectedRequest(request);
    setRequestDetailsOpen(true);
  };

  const handleCreateTOFromRequest = (request) => {
    // Here we can pre-fill the CreateTOOffcanvas
    // For now, let's just open it with the request data
    setEditData({ ...request, isFromRequest: true });
    setStaffRequestsOpen(false);
    setRequestDetailsOpen(false);
    setOffcanvasOpen(true);
  };

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>Mange TO</title>
        </MetaTags>
        <Container fluid>
          {/* Header Section */}
          <Row>
            <Col xl={4}>
              <DashBreadcrumb
                title="Service Orders"
                breadcrumbItem="Manage TO"
              />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center mb-3">
                <div className="DashbordFliter me-2">
                  <button
                    type="button"
                    className="btn btn-dark"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={toggleOffcanvas}
                  >
                    <i className="fa fa-plus me-2"></i>
                    Create TO
                  </button>
                </div>
                <div className="DashbordFliter me-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={handleReturnTO}
                  >
                    <i className="fa fa-reply me-2"></i>
                    Return TO
                  </button>
                </div>
                <div className="DashbordFliter me-2">
                  <button
                    type="button"
                    className="btn btn-dark"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={toggleStaffRequests}
                  >
                    <i className="fa fa-list me-2"></i>
                    Staff Requests
                  </button>
                </div>
                {/* {EXPORT_ALLOWED_USER_ROLES.includes(String(users?.role_id)) && (
                  <div>
                    <ServiceOrderExportReport />
                  </div>
                )} */}
              </div>
            </Col>
          </Row>

          <ToList
            onViewDetails={(to_number) => handleViewDetails(to_number)}
            transferOrderList={transferOrderList}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <CreateTOOffcanvas
            isOpen={isOffcanvasOpen}
            toggle={toggleOffcanvas}
            editData={editData}
          />
          <ReturnTOOffcanvas
            isOpen={isReturnOpen}
            toggle={toggleReturn}
          />
          <ItemDetailsOffcanvas
            isOpen={isItemDetailsOpen}
            toggle={toggleItemDetails}
            itemData={itemDetailsData}
          />
          <StaffRequestsOffcanvas
            isOpen={isStaffRequestsOpen}
            toggle={toggleStaffRequests}
            onViewDetails={handleViewRequestDetails}
            onCreateTO={handleCreateTOFromRequest}
          />
          <StaffRequestItemsOffcanvas
            isOpen={isRequestDetailsOpen}
            toggle={toggleRequestDetails}
            requestData={selectedRequest}
            onCreateTO={handleCreateTOFromRequest}
          />
        </Container>
        <Toaster
          position="top-right"
          reverseOrder={false}
          containerStyle={{ zIndex: 99999 }}
        />
      </div>
    </>
  );
};

export default ManageTO;
